import { parsePhoneNumberWithError } from 'libphonenumber-js';
import { Country, getCountryCallingCode } from 'react-phone-number-input';

/** US/Canada; every other calling code counts as international. */
const DOMESTIC_CALLING_CODE = '1';

/** The country of an E.164 number, or undefined when it can't be parsed. */
export function getPhoneNumberCountry(phoneNumber?: string | null): Country | undefined {
  if (!phoneNumber) return undefined;
  try {
    return parsePhoneNumberWithError(phoneNumber).country;
  } catch {
    return undefined;
  }
}

export function getCallingCode(country: Country | undefined) {
  return country ? getCountryCallingCode(country) : undefined;
}

export function isInternationalCallingCode(callingCode: string) {
  return callingCode !== DOMESTIC_CALLING_CODE;
}
